import React, { useState ,useEffect} from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "react-bootstrap-typeahead/css/Typeahead.css";
import trasportApi from "../../api/trasportApi";
import PubSub from 'pubsub-js';
import Select from "react-select";
import InfoPill from "../InfoPill";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { ShimmerTable } from "react-shimmer-effects";
import moment from "moment";
import Confirm from "../Confirm";

// React Icons Starts Here
import { FiEdit } from "react-icons/fi";
import { FaTrashAlt } from "react-icons/fa";
//React Icons Ends here.

const SubjectEdit = (props) => {

  const [body, setBody] = useState([]);
  const [validated, setValidated] = useState(false);
  const [isVechile, setBranch] = useState(props ? props.vechileRec : {challan_diesel_advance_date: moment().format("YYYY-MM-DD")});
  const [selectedFinancialYear, setSelectedFinancialYear] = useState({});
  const [financialYearOption, setOptionFinancialYear] = useState({});
  const [modalShow, setModalShow] = React.useState(false);
  const [branchName, setChallanBranchName] = useState({});
  const [challanDate, setChallanDate] = useState({});
  const [fnyear,setFinancialYear] = useState({});
  const [vechicleName, setVechicleName] = useState({});
  const [clinetName, setClientName] = useState({});

  const [selectedAdvanceBranch, setSelectedAdvanceBranch] = useState({});
  const [advanceBranchOption, setOptionAdvanceBranchOption] = useState({});

  const [selectedChallan, setSelectedChallan] = useState({});
  const [challanOption, setOptionChallan] = useState({});

  const [selectedVechicle, setSelectedVechicle] = useState({});
  const [vechicleOption, setVechicleOption] = useState({});


  useEffect(() => {
    const fetchData = async () => {
      
      const fnYear = await trasportApi.fetchAllActiveFinancialYears();
      const challanData = await trasportApi.fetchAllChallan();
      const branches = await trasportApi.fetchAllSupplier();
      
      //Branch
      if (branches && branches.length) {
        let ar = [];
        //eslint-disable-next-line
        branches.map((item) => {
          var obj = {};
          obj.value = item.id;
          obj.label = item.name;
          ar.push(obj);
        });
        if (props?.vechileRec) {
          let acc = ar.filter((acc) => acc.value === props.vechileRec.supplier_id);
          setSelectedAdvanceBranch(acc);
        }

        setOptionAdvanceBranchOption(ar);
      } else {
        setOptionAdvanceBranchOption([]);
      }

      //Year
      if (fnYear && fnYear.length) {
        let ar = [];
        fnYear.forEach((item) => {
          ar.push({ value: item.id, label: item.name });
        });

        const currentMonth = new Date().getMonth() + 1; // getMonth() is zero-based
        const currentYear = new Date().getFullYear();
        let defaultOption;

        if (currentMonth >= 3) { // March is the 3rd month
          defaultOption = ar.find(option => option.label === `${currentYear}-${currentYear + 1}`);
        } else {
          defaultOption = ar.find(option => option.label === `${currentYear - 1}-${currentYear}`);
        }

        if (defaultOption) {
          setSelectedFinancialYear(defaultOption);
          setBranch({ ...challanData, financial_year_id: defaultOption.value });
        } else if (props?.vechileRec) {
          const acc = ar.find((acc) => acc.value === props.vechileRec.financial_year_id);
          setSelectedFinancialYear(acc);
        }
        setOptionFinancialYear(ar);
      } else {
        setOptionFinancialYear([]);
      }

      if (challanData && challanData.length) {
        let ar = [];
        let tempAr = [];
        //eslint-disable-next-line
        challanData.map((item) => {
          var obj = {};
          obj.value = item.vehicle_id;
          obj.label = item.vehicle_number;
          ar.push(obj);
        });
     
        if (props?.vechileRec) {
          let acc = ar.filter((acc) => acc.value === props.vechileRec.vehicle_id);
          setSelectedVechicle(acc);
        }
        setVechicleOption(ar);
      } else {
        setVechicleOption([]);
      }

        //Challan Api Setup
        if (challanData && challanData.length) {
          //eslint-disable-next-line
          let challanOption = challanData.map((item) => ({
            value: item.id,
            label: item.challan_no,
            branch_name : item.branch_name,
            client_name : item.client_name,
            vehicle_number : item.vehicle_number,
            financial_year_name : item.financial_year_name,
            challan_date : item.challan_date,
            client_id : item.client_id
          }));
     
        if (props.vechileRec.id && props?.vechileRec) {
          let acc = challanOption.filter((acc) => acc.value === props.vechileRec.challan_id);
          console.log("acc",acc);
          setClientName(acc[0].client_name);
          setChallanBranchName(acc[0].branch_name);
          setVechicleName(acc[0].vehicle_number);
          setFinancialYear(acc[0].financial_year_name);
          setChallanDate(acc[0].challan_date);
          setSelectedChallan(acc);
        }
        setOptionChallan(challanOption);
      } else {
        setOptionChallan([]);
      }
    };
  
    fetchData();
  }, []);
 
  // const checkRequiredFields = () => {
  //   if (
  //     isVechile.vehicle_number &&
  //     isVechile.vehicle_number.trim() !== "" &&
  //     isVechile.transporter_id &&
  //     isVechile.transporter_id.trim() !== "" &&
  //     isVechile.rc_owner &&
  //     isVechile.rc_owner.trim() !== "" &&
  //     isVechile.financial_year_id &&
  //     isVechile.financial_year_id.trim() !== ""
  //   ) {
     
  //     return false;
  //   }
  //   return true;
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    isVechile.client_id = selectedChallan.client_id;
    
    // if (checkRequiredFields()) {
    //   setValidated(true);
    //   return;
    // }
    let result2 = {};
    
    if (isVechile.id) {
      console.log("d",isVechile);
      result2 = await trasportApi.saveAdvanceDieselChallan(isVechile);
      if (result2.success) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record Updated successfully' });
        fetchAllAdvanceChallanRecords(result2);
      }
    } else {
      result2 = await trasportApi.createAdvanceDieselChallan(isVechile);
      if (result2?.id) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record saved successfully' });
        fetchAllAdvanceChallanRecords(result2);
      } else {
        //submitDoctorDuties();
        //PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record ERROR', message: result2.errors[0].msg });
      }
    }

  };

  const handlefinancialYear = (e) => {
    setSelectedFinancialYear(e);
    setBranch({ ...isVechile, financial_year_id: e.value });
  };

  const handleChallan = (e) => {
    setSelectedChallan(e);
    setBranch({ ...isVechile, challan_id: e.value });
  };
  
  const handleBranch = (e) => {
    setSelectedAdvanceBranch(e);
    setBranch({...isVechile,supplier_id : e.value});
  };

  const handleVechile  = async (e) => {
    console.log("event",e);
    let vechicleId =  e;
    console.log("object",vechicleId)
    if(vechicleId){
      setBranch({ ...isVechile, vehicle_id: vechicleId.value});
      const challanRecData = await trasportApi.fetchChallanByVehicleId(vechicleId?.value);
      if (challanRecData && challanRecData.length) {
        //eslint-disable-next-line
        let challanOption = challanRecData.map((item) => ({
          value: item.id,
          label: item.challan_no,
          branch_name : item.branch_name,
          client_name : item.client_name,
          vehicle_number : item.vehicle_number,
          financial_year_name : item.financial_year_name,
          challan_date : item.challan_date,
          client_id : item.client_id
        }));
        
        if (props?.vechileRec) {
          let acc = challanOption.filter((acc) => acc.value === props.vechileRec.challan_id);
          setSelectedChallan(acc);
        }

        setOptionChallan(challanOption);
        setSelectedVechicle(vechicleId);
      } else {
        setOptionChallan([]);
      }
    }
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
  
    // Update the branch state dynamically
    const updatedBranch = { ...isVechile, [name]: value };
  
    // Calculate the total amount if qty or rate is updated
    if (name === "qty" || name === "rate") {
      const qty = parseFloat(updatedBranch.qty) || 0; 
      const rate = parseFloat(updatedBranch.rate) || 0; 
      updatedBranch.total_amount = (qty * rate).toFixed(2); 
    }
    console.log("updatedBranch",updatedBranch);
  
    setBranch(updatedBranch);
  };

  const header = [
    {
      title: "Challan Diesel Date",
      prop: "challan_diesel_advance_date",
      isSortable: true,
      isFilterable: true,
      cell: (row) => (
        <span>
          {row.challan_diesel_advance_date
            ? moment(row.challan_diesel_advance_date).format("DD MMM, yyyy")
            : ""}
        </span>
      ),
    },
    { title: "Supplier Name", prop: "supplier_name", isFilterable: true },
    { title: "Qty", prop: "qty", isFilterable: true },
    { title: "Rate (Price)", prop: "rate", isFilterable: true },

    {
      title: "Diesel Challan Amount",
      prop: "advance_amount",
      isFilterable: true,
    },
    // { title: "Pan Number", prop: "pan_number", isFilterable: true },
    // { title: "Engine Number", prop: "engine_number", isFilterable: true },
    // { title: "Chasis Number", prop: "chasis_number", isFilterable: true },
    
    { title: "Remark", prop: "remark", isFilterable: true },
    {
      title: "Financial Year",
      prop: "financial_year_name",
      isFilterable: true,
    },
    { title: "Created By", prop: "createdbyname", isFilterable: true },
    {
      title: "Lastmodified By",
      prop: "lastmodifiedbyname",
      isFilterable: true,
    },
  ];

  header.push({
    title: "Actions",
    prop: "id",
    cell: (row) => (
      <div>
        <Button
          className="btn-sm mx-1"
          onClick={() => editFinancialYearList(row)}
        >
          <FiEdit />
        </Button>
        <Button
          variant="danger"
          className="btn-sm mx-1"
          onClick={() => handleDelete(row)}
        >
          <FaTrashAlt />
        </Button>
      </div>
    ),
  });
    const labels = {
      beforeSelect: " ",
    };

    const editFinancialYearList = (row) => {
      // setModalShowEditBranch(true);
      setBranch(row); 
    }
    const handleDelete = (row) => {
      console.log(row);
      setModalShow(true);
      setBranch(row);
    }

    const isdelete = async () => {    
      const result = await trasportApi.deleteAdvanceDieselChallan(isVechile.id);
      if (result.success) {
        setBranch('');
        setModalShow(false);
        fetchAllAdvanceChallanRecords();
      }
    }
    
    //Retrive Data From Server Backend When User Save or Create Records.

    const fetchAllAdvanceChallanRecords = async (result2) => {
      const result = await trasportApi.fetchAdvanceDieselChallanById(result2.id);
      if(result){
        setBody(result);
      }

    }
  return (
    <Modal {...props} size="xl" style={{}}>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title">
        Diesel Challan Information
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="view-form">
          <Row>
            <Col lg={12}>
              <Form
                className="mt-3"
                onSubmit={handleSubmit}
                controlId="subjectCreate"
                noValidate validated={validated}
              >
                <Row>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                  Advance Challan Financial Year
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Financial Year"
                      value={selectedFinancialYear}
                      onChange={handlefinancialYear}
                      options={financialYearOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Financial Year.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                    Vehicle Number
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Vehicle Number"
                      value={selectedVechicle}
                      onChange={handleVechile}
                      options={vechicleOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Financial Year.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                         Challan Date
                      </Form.Label>
                      <Form.Control
                        disabled
                        type="date"
                        placeholder="Challan Date"
                        value={selectedChallan.challan_date ? moment(selectedChallan.challan_date).format(
                              "YYYY-MM-DD"
                              )
                                : moment(challanDate).format(
                                  "YYYY-MM-DD"
                                  )
                              }
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                    Challan Number
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Financial Year"
                      value={selectedChallan}
                      onChange={handleChallan}
                      options={challanOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Challan Number.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                    Party/Client Name
                    </Form.Label>
                    <Form.Control
                        disabled
                        placeholder="Client Name"
                        value={selectedChallan.client_name ? selectedChallan.client_name  : clinetName}
                        // onChange={handleVechile }
                        style={{ height: "38px" }}
                      />
                    <Form.Control.Feedback type="invalid">
                      Please Enter Party/Client Name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                    Challan Branch Name
                    </Form.Label>
                    <Form.Control
                        disabled
                        placeholder="Branch Name"
                        value={selectedChallan.branch_name ? selectedChallan.branch_name  : branchName}
                        // onChange={handleVechile }
                        style={{ height: "38px" }}
                      />
                    <Form.Control.Feedback type="invalid">
                      Please Enter Challan Branch Name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                   Challan Vehicle Number
                    </Form.Label>
                    <Form.Control
                        disabled
                        placeholder="Vehicle Number"
                        value={selectedChallan.vehicle_number ? selectedChallan.vehicle_number : vechicleName}
                        // onChange={handleVechile }
                        style={{ height: "38px" }}
                      />
                    <Form.Control.Feedback type="invalid">
                      Please Enter Vehicle Number.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                    Financial Year Name (Challan)
                    </Form.Label>
                    <Form.Control
                        disabled
                        placeholder="Financial Year Name"
                        value={selectedChallan.financial_year_name ? selectedChallan.financial_year_name : fnyear}
                        // onChange={handleVechile }
                        style={{ height: "38px" }}
                      />
                    <Form.Control.Feedback type="invalid">
                      Please Enter Financial Year Name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                  <Row>
                     <Col className="section-header my-3">
                         <span style={{ color: "blue", paddingLeft: "10px" }}>
                         Diesel Challan Information
                          </span>
                     </Col>
                  </Row>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                      Diesel Challan Date
                      </Form.Label>
                      <Form.Control
                        required
                        type="date"
                        name="challan_diesel_advance_date"
                        placeholder="Select Challan Diesel Date"
                        value={isVechile.challan_diesel_advance_date ? moment(isVechile.challan_diesel_advance_date).format(
                              "YYYY-MM-DD"
                            )
                          : ""}
                        onChange={handleChange }
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                    Supplier
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Supplier"
                      value={selectedAdvanceBranch}
                      onChange={handleBranch}
                      options={advanceBranchOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Challan Number.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                     Quantity
                    </Form.Label>
                   <Form.Control
                        type="number"
                        name="qty"
                        placeholder="Enter a Qty"
                        value={isVechile.qty}
                        onChange={handleChange }
                        style={{ height: "38px" }}>
                   </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      Please Enter Qty.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                    Rate (Price ₹)
                    </Form.Label>
                   <Form.Control
                        type="number"
                        name="rate"
                        placeholder="Enter Rate Amount"
                        value={isVechile.rate}
                        onChange={handleChange }
                        style={{ height: "38px" }}>
                   </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      Please Enter Rate Amount.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                    Total Amount
                    </Form.Label>
                   <Form.Control
                        disabled
                        type="number"
                        name="total_amount"
                        placeholder="Total Amount"
                        value={isVechile.total_amount}
                        onChange={handleChange }
                        style={{ height: "38px" }}>
                   </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      Please Enter Rate Amount.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                      Remark
                      </Form.Label>
                      <Form.Control
                         as="textarea"
                        name="remark"
                        placeholder="Enter remark"
                        value={isVechile.remark}
                        onChange={handleChange}
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
          <Row>
          {modalShow &&
            <Confirm
              show={modalShow}
              onHide={() => setModalShow(false)}
              isdelete={isdelete}
              title="Confirm delete?"
              message="You are going to delete the record. Are you sure?"
              table="Vehicle"
            />}

          <Col lg={12} className="p-lg-4">
          {body && Object.keys(body).length > 0 && (
            <Row>
               <Col className="view-form-header align-items-center"lg={12}>
                  Advance Challan Entry Information
                </Col>
            </Row>
            
          )}
          {body && Object.keys(body).length > 0 && (
            <DatatableWrapper
              body={[body]}
              headers={header}
            >
              <Table striped className="data-table mt-2">
                <TableHeader />

                <TableBody />
              </Table>

              {/* <Pagination /> */}
            </DatatableWrapper>
          )}
        </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide} variant="light">
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal >
  );
};
export default SubjectEdit;